import React from 'react'
import { useSelector } from 'react-redux'
import { selectNetwork } from '../redux/features/ui/uiSlice'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const classes = {
  // The one part of the menu bar that gives way when the window is narrow: a
  // long message (a refused title's reason) is cut short with an ellipsis
  // rather than pushing the links off the end. The whole of it is the title.
  box: {
    display: 'flex',
    flexGrow: 1,
    minWidth: 0,
    justifyContent: 'flex-end',
    paddingLeft: 1,
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}

export default function SavingIndicator() {
  const network = useSelector(selectNetwork)

  const text = network.hasError
    ? `Error: ${network.errorMessage}`
    : network.isFetching
    ? 'Saving'
    : 'Saved'

  return (
    <Box sx={classes.box}>
      <Typography variant='p' sx={classes.text} title={text}>
        {text}
      </Typography>
    </Box>
  )
}
